.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0px;
}
.pageSection {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}